import $ from 'jquery';

export default function () {

    $(document).on('click', 'a', function () {
        if (!window.ga) {
            return false;
        }

        const ga = window.ga;

        const GaAction = $(this).data('event-action');

        function getRootUrl() {
            return window.location.origin ? window.location.origin : window.location.protocol + '/' + window.location.host + '/';
        }

        const SiteUrl = getRootUrl();

        if (GaAction === 'Share:Facebook') {
            ga('send', 'social', 'Facebook', 'share', SiteUrl);
            return ga('rollup.send', 'social', 'Facebook', 'share', SiteUrl);
        }

        if (GaAction === 'Share:Twitter') {
            ga('send', 'social', 'Twitter', 'tweet', SiteUrl);
            return ga('rollup.send', 'social', 'Twitter', 'tweet', SiteUrl);
        }

        if (GaAction === 'Share:Linkedin') {
            ga('send', 'social', 'Linkedin', 'share', SiteUrl);
            return ga('rollup.send', 'social', 'Linkedin', 'share', SiteUrl);
        }

        if (GaAction === 'Share:Email') {
            ga('send', 'social', 'Email', 'email', SiteUrl);
            return ga('rollup.send', 'social', 'Email', 'email', SiteUrl);
        }

        if (GaAction === 'Clicked: Announcement') {
            ga('send', 'event', 'User', 'Clicked: Announcement', 'Google IO');
            return ga('rollup.send', 'event', 'User', 'Clicked: Announcement', 'Google IO');
        }
    });

}
